import React, { useState, useEffect, useRef } from "react"
import { Link } from "react-router-dom"
import {
  Table,
  CardBody,
  CardTitle,
  Button,
  Col,
  Row,
  UncontrolledAlert,
  Spinner,
} from "reactstrap"
import api from "API/Api"
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation"

const AddMaterial = () => {
  const formRef = useRef(null)
  const user = localStorage.getItem("authUser")
  const userInfo = JSON.parse(user)
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
    const response = await api.post("create-unit", values)
    if (response.data.success === true) {
      setSubmitted(true)
      formRef.current.reset()
    }
    } catch (error) {

      // Handled by global interceptor

    }

    setLoading(false)
  }

  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}>
              <h4>Add Material Unit Type</h4>
            </Col>
            <Col md={6} style={{ textAlign: "right" }}>
              <Link to="/material-unit-type" className="dashBtn">
                <i className=" fas fa-chevron-left "></i> <b> Back</b>
              </Link>
            </Col>
          </Row>
        </div>
        <div className="dashContent">
          <AvForm
            style={{ position: "relative" }}
            className="form-horizontal"
            ref={formRef}
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v, "create")
            }}
          >
            <div className="mb-3">
              <AvField
                name="unitName"
                label="Material Unit Type Name"
                value=""
                className="form-control"
                placeholder="Enter Plant Name"
                type="text"
                required
              />
            </div>
            <div className="mb-3">
              <AvRadioGroup
                inline
                name="allowDecimal"
                label=" Allow Decimal Values for this Unit Type"
                required
                errorMessage="Pick one!"
              >
                <AvRadio label="Yes" value="1" />
                <AvRadio label="No" value="0" />
              </AvRadioGroup>
            </div>
            <AvField
              name="addedBy"
              value={userInfo.uid}
              type="hidden"
              required
            />

            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (
                  <UncontrolledAlert color="success">
                    <strong>Material Unit Type is Added!</strong>
                  </UncontrolledAlert>
                ) : null}
              </div>
              <div className="col-6 text-end">
                <button
                  className="btn btn-primary w-md waves-effect waves-light"
                  type="submit"
                      disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" />
                      <span style={{ paddingLeft: "10px" }}>Adding...</span>
                    </>
                  ) : (
                    <span>Add Material Unit </span>
                  )}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default AddMaterial
